var path = 'app/scripts/modules/core/src/pipeline/config/stages/common/stepLabel.html';
var html = "<span class=\"task-label\">{{ step.name | robotToHuman }}</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;